import React from 'react';

export default () => {
    return (
        <React.Fragment>
            <i
                style={{ marginLeft: '16px', cursor: 'pointer', fontSize: '16px' }}
                className={'icon-Reset sct-icon'}
                onClick={() => window.dispatchEvent(new CustomEvent('marshal-reset'))}
            ></i>
        </React.Fragment>
    );
};
